<template>
  <div>
    <div class="bg-body"/>
    <div>
      <div class="messages-head-bg"/>
      <div class="messages-head-previous" @click="previous">
        <div><img src="@/assets/img/messages/previous.png"></div>
        <div>Messages</div>
      </div>
      <div class="col-md-12 file-head-content">
        <div class="file-header">
          <div class="col-10">
            <div class="file-header-title">Centre</div>
          </div>
          <div class="col-2 file-header-logo"><img src="@/assets/img/logo.png"></div>
        </div>
      </div>
    </div>

    <div class="messages-info">
      <div class="messages-info-content">
        <div class="messages-info-header">
          <div class="messages-info-header-icon "><img src="@/assets/img/messages/radar.png"></div>
          <div class="messages-info-header-label">Votre centre de formation</div>
        </div>

        <div class="messages-info-text">Le centre de formation qui traite votre candidature est :</div>

        <br>
        <div class="messages-info-bold">{{ campus }}</div>
        <div class="messages-info-fine">{{ campusAddress }}</div>

        <br>
        <div class="messages-info-bold">Horaires d'ouverture :</div>
        <div class="messages-info-fine">Du lundi au vendredi / 9h - 16h</div>

        <br>
        <div class="messages-info-bold" v-if="ofVacationDateAsString !== ''" >Congés annuels de votre centre de rattachement :</div>
        <div class="messages-info-fine" v-if="ofVacationDateAsString !== ''" >{{ ofVacationDateAsString }}</div>

      </div>
    </div>

    <div class="messages-description">
      <div class="messages-description-contenu">
        Lors de votre inscription définitive, le centre de formation peut être différent (en fonction des distances, de votre mobilité, des places disponibles, etc...).
      </div>
    </div>

    <div class="form-group">
      <button class="btn btn-primary btn-block" @click="actionMail">
        <span>Écrire au centre</span>
      </button>
    </div>

    <div class="form-group">
      <button class="btn btn-white btn-block" @click="actionPhone">
        <span class="messages-group-menu-icon-right "><img src="@/assets/img/messages/phone.png" alt="Appeler {{ campusPhone }}"/>{{ campusPhone }}</span>
      </button>
    </div>
  </div>
</template>

<script>

import UserService from "@/services/user.service";

export default {
  name: "MessagesContact",
  data() {
    return {
      campus: null,
      campusAddress: null,
      campusPhone: null,
      campusMail: null,
      ofVacationDateAsString: null
    }
  },
  mounted() {
    UserService.getDashboardContent("MessagesContact").then(
        (response) => {
          this.campus = response.data.campus
          this.campusAddress = response.data.campusAddress
          this.campusPhone = response.data.campusPhone
          this.campusMail = response.data.campusMail
          this.ofVacationDateAsString = response.data.ofVacationDateAsString
        },
        (error) => {
          this.content =
              (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
              error.message ||
              error.toString();
        }
    );
  },
  methods: {
    actionMail: function () {
      window.location.href = "mailto:" + this.campusMail;
    },
    actionPhone: function () {
      window.location.href = "tel:" + this.campusPhone;
    },
    previous: function () {
      this.$router.push({name: 'messages'});
    }
  }
};
</script>
